import axios from '../axiosApi';
import {
    FETCH_AUTOCLAVE_CICLO_SUBCICLO,
    FETCH_AUTOCLAVE_CICLOS,
    FETCH_AUTOCLAVE_DETALHES_CICLO,
    FETCH_AUTOCLAVE_HISTORICO_INDICADORES, FETCH_AUTOCLAVE_UTILIZACAODATA,
    FETCH_AUTOCLAVES,
    POST_AUTOCLAVE_CICLO_ORDEM_SERVICO,
    POST_SUCCESS_AUTOCLAVE_CICLO_ORDEM_SERVICO,
    RECEIVE_AUTOCLAVE_CICLO_SUBCICLO,
    RECEIVE_AUTOCLAVE_CICLOS,
    RECEIVE_AUTOCLAVE_DETALHES_CICLO,
    RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES, RECEIVE_AUTOCLAVE_UTILIZACAODATA,
    RECEIVE_AUTOCLAVES
} from "./actionTypes";

export const fetchAutoclaves =  () => ({
    type: FETCH_AUTOCLAVES
});

export const receiveAutoclaves = payload => ({
    type: RECEIVE_AUTOCLAVES,
    payload: payload
});

export const fetchAutoclaveCiclos =  () => ({
    type: FETCH_AUTOCLAVE_CICLOS
});

export const receiveAutoclaveCiclos = payload => ({
    type: RECEIVE_AUTOCLAVE_CICLOS,
    payload: payload
});

export const fetchAutoclaveCicloSubciclo =  () => ({
    type: FETCH_AUTOCLAVE_CICLO_SUBCICLO
});

export const receiveAutoclaveCicloSubCiclo = payload => ({
    type: RECEIVE_AUTOCLAVE_CICLO_SUBCICLO,
    payload: payload
});


export const fetchAutoclaveDetalhesCiclo =  () => ({
    type: FETCH_AUTOCLAVE_DETALHES_CICLO
});

export const receiveAutoclaveDetalhesCiclo = payload => ({
    type: RECEIVE_AUTOCLAVE_DETALHES_CICLO,
    payload: payload
});

export const fetchAutoclaveHistoricoIndicadores =  () => ({
    type: FETCH_AUTOCLAVE_HISTORICO_INDICADORES
});

export const receiveAutoclaveHistoricoIndicadores = payload => ({
    type: RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES,
    payload: payload
});


export const fetchAutoclaveUtilizacaoData =  () => ({
    type: FETCH_AUTOCLAVE_UTILIZACAODATA
});

export const receiveAutoclaveUtilizacaoData = payload => ({
    type: RECEIVE_AUTOCLAVE_UTILIZACAODATA,
    payload: payload
});

export const dpPostAutoclaveCicloOrdemServico =  () => ({
    type: POST_AUTOCLAVE_CICLO_ORDEM_SERVICO
});

export const dpPostSuccessAutoclaveCicloOrdemServico = payload => ({
    type: POST_SUCCESS_AUTOCLAVE_CICLO_ORDEM_SERVICO,
    payload: payload
});
////////////////////////////////////

export const getAutoclaves = () => {
    return async dispatch => {
        dispatch(fetchAutoclaves());
        let payload;
        try {
            const response = await axios.get(`/autoclaves`)
            payload = response.data;
            console.log("autoclaves response", response);
        }
       catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveAutoclaves(payload));
        }
    }
};

export const getAutoclaveCiclos = () => {
    return async (dispatch, getState) => {


        dispatch(fetchAutoclaveCiclos());
        let payload;
        try {



            if (getState().autoclaves.Autoclaves.length === 0) {

                await dispatch(getAutoclaves());
            }



            let rCiclos = [];
            let res = []



            await Promise.all(
                getState().autoclaves.Autoclaves.map( async (a) => {
                    console.log("getAutoclaveCiclos", a.id, a.codigo)
                   const r = await axios.get(`/autoclaves/${a.id}/autoclave-ciclo-checks`);

                   let x = []
                   r.data.map( (c) => {
                       let ano = 2000;
                       if (c.dtIni && c.dtIni.length > 4){
                           try {
                               ano = c.dtIni.substring(0, 4) * 1;
                           } catch {}
                       }
                       x.push({
                           id: c.id,
                           codigo: a.codigo,
                           autoclaveId: a.id,
                           ciclo: c.ciclo+c.subciclo,
                           DTInicio: c.dtIni,
                           DTFinal: c.dtUltW,
                           amostras: c.contadorCapturas? c.contadorCapturas : 'N/A',
                           ano : ano,

                       });
                   })

                   rCiclos = [...rCiclos, ...x];
               })
            )

            await Promise.all(
                res = rCiclos.sort((a, b) => {
                    if (a.DTFinal > b.DTFinal) return -1;
                    if (a.DTFinal < b.DTFinal) return 1;
                    return 0;
                })
            )





            payload = res;

        }
       catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveAutoclaveCiclos(payload));
        }
    }
};


export const getAutoclaveCicloSubCiclo = (autoclaveId) => {
    //
    return async dispatch => {
        dispatch(fetchAutoclaveCicloSubciclo());
        let payload;
        try {
            const response = await axios.get(`/autoclaves/${autoclaveId}/autoclave-ciclo-checks?filter={ "order": ["dtUltW DESC"], "limit": 1 }`)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveAutoclaveCicloSubCiclo(payload));
        }
    }
}

function processTagAlarmes(tagsCatalog, historicos) {
    if (!Array.isArray(tagsCatalog) || !Array.isArray(historicos) || historicos.length === 0) {
        return { series: [], categories: [] };
    }

    var alarmTags = tagsCatalog.filter(function(t) {
        return t.propriedade && t.propriedade.toLowerCase().indexOf('alm') === 0;
    });

    var tagMap = {};
    alarmTags.forEach(function(t) {
        tagMap[t.propriedade] = t;
    });

    var triggeredAlarms = {};
    var parsedRecords = historicos.map(function(h) {
        var tags = {};
        if (h.tags) {
            try {
                var parsed = typeof h.tags === 'string' ? JSON.parse(h.tags) : h.tags;
                if (parsed && typeof parsed === 'object') {
                    tags = parsed;
                }
            } catch (e) { /* ignore parse errors */ }
        }
        Object.keys(tags).forEach(function(key) {
            if (tagMap[key] && (tags[key] === true || tags[key] === 'true' || tags[key] === 1)) {
                triggeredAlarms[key] = true;
            }
        });
        return tags;
    });

    var triggeredKeys = Object.keys(triggeredAlarms).sort();
    if (triggeredKeys.length === 0) {
        return { series: [], categories: [] };
    }

    var categories = triggeredKeys.map(function(key) {
        return tagMap[key].descricao || tagMap[key].codigo || key;
    });

    var series = triggeredKeys.map(function(key, idx) {
        return {
            name: (tagMap[key].codigo || key) + ' - ' + (tagMap[key].descricao || key),
            data: parsedRecords.map(function(tags) {
                var val = tags[key];
                return (val === true || val === 'true' || val === 1) ? idx : null;
            })
        };
    });

    return { series: series, categories: categories };
}

export const getAutoclaveHistoricoIndicadores = (autoclaveId, ciclo) => {
    return async  (dispatch, getState ) => {
        dispatch(fetchAutoclaveHistoricoIndicadores());
        let payload;
        try {

            const response  = await axios.get(`autoclaves/${autoclaveId}/${ciclo}/indicadores`);

            const response2 = await axios.get(`autoclaves/${autoclaveId}/${ciclo}/eventos`);

            const response3 = await axios.get(`autoclaves/${autoclaveId}/${ciclo}/alarmes`);

            const response4 = await axios.get(`autoclaves/${autoclaveId}/${ciclo}/presets`);

            const response5 = await axios.get(`autoclaves/${autoclaveId}/${ciclo}/distinctpresets`);

            const ac = getState().autoclaves.Autoclaves.find( (a) => a.id === autoclaveId);

            // Fetch tag-based alarms from autoclave-historicos tags JSON
            let tagAlarmes = { series: [], categories: [] };
            try {
                // Tags filter: use protocoloComunicacao if available, otherwise fetch all
                var tagFilter = (ac && ac.protocoloComunicacao)
                    ? '{"where":{"modeloCLP":"' + ac.protocoloComunicacao + '"}}'
                    : '{}';

                // Build autoclave-historicos filter using cycle date range
                var histFilter = null;

                // Strategy 1: date range from AutoclaveCiclos state
                var allCiclos = getState().autoclaves.AutoclaveCiclos;
                if (Array.isArray(allCiclos) && allCiclos.length > 0) {
                    var cicloInfo = allCiclos.find(function(c) {
                        return String(c.autoclaveId) === String(autoclaveId) && String(c.ciclo) === String(ciclo);
                    });
                    if (cicloInfo && cicloInfo.DTInicio && cicloInfo.DTFinal) {
                        histFilter = '{"where":{"createdOn":{"between":["' + cicloInfo.DTInicio + '","' + cicloInfo.DTFinal + '"]}},"order":"createdOn ASC"}';
                    }
                }

                // Strategy 2: fetch ciclo-check from API to get date range
                if (!histFilter) {
                    var checkRes = await axios.get('/autoclaves/' + autoclaveId + '/autoclave-ciclo-checks');
                    if (Array.isArray(checkRes.data)) {
                        var matchingCheck = checkRes.data.find(function(c) {
                            return String(c.ciclo) + String(c.subciclo) === String(ciclo)
                                || String(c.ciclo + c.subciclo) === String(ciclo);
                        });
                        if (matchingCheck && matchingCheck.dtIni && matchingCheck.dtUltW) {
                            histFilter = '{"where":{"createdOn":{"between":["' + matchingCheck.dtIni + '","' + matchingCheck.dtUltW + '"]}},"order":"createdOn ASC"}';
                        }
                    }
                }

                console.log("tagAlarmes: histFilter=", histFilter);

                if (histFilter) {
                    var tagsRes = await axios.get('/tags?filter=' + tagFilter);
                    var histRes = await axios.get('/autoclaves/' + autoclaveId + '/autoclave-historicos?filter=' + histFilter);

                    console.log("tagAlarmes: tags=", tagsRes.data.length, "historicos=", histRes.data.length);

                    tagAlarmes = processTagAlarmes(tagsRes.data, histRes.data);

                    console.log("tagAlarmes: triggered=", tagAlarmes.series.length, tagAlarmes.categories);
                }
            } catch (tagErr) {
                console.log("processTagAlarmes error:", tagErr);
            }

            payload = {
                autoclaveId: autoclaveId,
                autoclaveCodigo: ac.codigo,
                ciclo: ciclo,
                indicadores: response.data,
                eventos: response2.data,
                alarmes: response3.data,
                presets: response4.data,
                distinctpresets: response5.data,
                tagAlarmes: tagAlarmes
            }
        }
        catch(e) {
            //console.log("ERROR getAutoclaveHistoricoIndicadores ", e, autoclaveId, ciclo)
            payload = { error: true };
        }
        finally {
            dispatch(receiveAutoclaveHistoricoIndicadores(payload));
        }
    }
};

export const getOSPorEtapaMaquinaCiclo = (etapa, maquinaId, cicloId) => {
    return async dispatch => {
        dispatch(fetchAutoclaveDetalhesCiclo());
        let payload;
        try {

          //  const url = `/AutoclaveCiclos?filter={"where":{"id":${cicloId}},"include":["autoclave",{"autoclaveCicloOrdemServicos":{"serviceOrderStep":{"serviceOrder":[{"tireModel":"tireBrand"},"tireSize",{"tireBand":"tireBandBrand"}]}}}]}`;

            console.log('getOSPorEtapaMaquinaCiclo.preload')
            const url = `/ordem-servicos/os-por-etapa-maquina-ciclo?etapa=${etapa}&maquina=${maquinaId}&ciclo=${cicloId}`;
            console.log("LISTA DETALHES OS DO CICLO", url);

           const response = await axios.get(url)
            console.log('getOSPorEtapaMaquinaCiclo.posget')


           payload = {
               error: false,
               result: "OK",
               message: "",
               data: response.data
           };
        }
       catch(e) {
           payload = {
               error: true,
               result: "FAIL",
               message: e,
               data: {}
           };
           console.log("")
        }
        finally {
            dispatch(receiveAutoclaveDetalhesCiclo(payload));
        }
    }
};

export const addAutoclaveCicloOrdemServico = (data) => {
    return async (dispatch, getState) => {

        const estabelecimento =  getState().filter.estabelecimentoId;
        data = {
            ...data,
            estabelecimentoId : parseInt(estabelecimento)
        }
        console.log("autoclaveAction.addAutoclaveCicloOrdemServico", data)
        dispatch(dpPostAutoclaveCicloOrdemServico());
        let payload;

        try {
            const response = await axios.post(`/ordem-servicos/addOSRapida`, data)
            console.log('addAutoclaveCicloOrdemServico response', response)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
            console.log("addAutoclaveCicloOrdemServico ERROR", e);
        }
        finally {
            dispatch(dpPostSuccessAutoclaveCicloOrdemServico(payload));
        }
    }
}



export const getAutoclavesUtilizacaoData = () => {
    return async  (dispatch, getState) => {
        dispatch(fetchAutoclaveUtilizacaoData());
        let payload;
        try {
            const { periodMin, periodMax } = getState().filter;
            const url = `/autoclaves/utilizacaoData?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log("getAutoclavesUtilizacaoData url", url)

            const response = await axios.get(url);
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
            console.log("getAutoclavesUtilizacaoData error", e)
        }
        finally {
            dispatch(receiveAutoclaveUtilizacaoData(payload));
        }
    }
};

export const postAutoclaveLicenca = (aId, numero) => {
    return async dispatch => {
        dispatch(fetchAutoclaves());
        let payload;
        try {
            const obj = {
                licencaNumCiclosLiberados: numero
            }
            const response = await axios.patch(`/autoclaves/${aId}`,obj)
            payload = response.data;
            console.log("autoclaves response", response);
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveAutoclaves(payload));
        }
    }
};